import { EditSingleMemberFirmCreationRequest } from '@bupa-kkv/features/company-creation/types';
import { queryKeyStore } from '@bupa-monorepo/shared-frontend/query-key-store';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { editSelfEmploymentCreations } from '../../api/self-employment/edit-self-employment-creations';

export const useEditSelfEmploymentCreations = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: EditSingleMemberFirmCreationRequest) =>
      editSelfEmploymentCreations(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey:
          queryKeyStore.companyCreation.selfEmploymentCreations.queryKey,
      });
    },
  });
};
